import {
  DvFilterRangeKeys,
  DvPeriodPickerControlValue,
} from '@devinco/ui/legacy';
import DateUtils from '@shared/utils/date.utils';

export default class ExcelExportUtils {
  static getCapitalizedFileName(currentTranslation: string): string {
    const capitlalizedArr = currentTranslation.split(' ').map(word => {
      // capitalize each word's first letter
      return word.charAt(0).toUpperCase() + word.slice(1);
    });

    return capitlalizedArr.join('');
  }

  static getCustomPeriodExcelFileName = (
    datePeriodControlValue?: DvPeriodPickerControlValue,
    selectedFilterPresetName?: string
  ): string => {
    let fileName = '';

    if (selectedFilterPresetName) {
      fileName += `_${selectedFilterPresetName}`;
    }

    if (datePeriodControlValue) {
      if (
        datePeriodControlValue.selectedFilter?.filterKey ===
        DvFilterRangeKeys.Today
      ) {
        fileName += `_${DateUtils.convertDateTimeToNO(new Date(), true)}`;
      } else if (
        datePeriodControlValue.selectedFilter?.filterKey ===
        DvFilterRangeKeys.Yesterday
      ) {
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        fileName += `_${DateUtils.convertDateTimeToNO(yesterday, true)}`;
      } else if (
        datePeriodControlValue.start &&
        datePeriodControlValue.end &&
        datePeriodControlValue.start.toDateString() ===
          datePeriodControlValue.end.toDateString()
      ) {
        fileName += `_${DateUtils.convertDateTimeToNO(
          datePeriodControlValue.start,
          true
        )}`;
      } else {
        if (datePeriodControlValue.start) {
          fileName += `_${DateUtils.convertDateTimeToNO(
            datePeriodControlValue.start,
            true
          )}`;
        }

        if (datePeriodControlValue.end) {
          fileName += `_${DateUtils.convertDateTimeToNO(
            datePeriodControlValue.end,
            true
          )}`;
        }

        if (
          !datePeriodControlValue.start &&
          !datePeriodControlValue.end &&
          datePeriodControlValue.selectedFilter?.title
        ) {
          fileName += `_${datePeriodControlValue.selectedFilter.title}`;
        }
      }
    }

    return fileName;
  };
}
